import React from 'react';
import config from 'react-global-configuration';
import { CoreLink, Menu } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { DOMAIN_VNL } from '../../../config/constants';
import NavigationMobileMenuItem from './NavigationMobileMenuItem';

import './style.scss';

const NavigationMainMenuMobile = ({
  items,
  handleLinkClick,
  setOpenMobileMenu,
  closeAllModals,
}) => {
  const menuIdSuffix = config.get('CURRENT_DOMAIN') !== DOMAIN_VNL ? `-${config.get('CURRENT_DOMAIN')}` : '';

  return (
    <div className="LegacyNavigationMainMenuMobile__items">
      {items.map((item) => {
        const key = item.getIn(['link', 'meta_data', 'entity_id']);
        return (
          <NavigationMobileMenuItem
            closeAllModals={closeAllModals}
            key={key}
            item={item}
            handleLinkClick={handleLinkClick} />
        );
      })}
      <Container>
        <Menu id={`secondary-navigation${menuIdSuffix}`}>
          {(links) => {
            return (
              <ul className="secondary-navigation__items">
                {links.map((link, index) => {
                  if (!link) {
                    return;
                  }
                  const title = link.getIn(['link', 'title'], 'Untitled');
                  const url = link.getIn(['link', 'url'], '');
                  const subTree = link.get('subtree', '');

                  return (
                    <li key={title} className={`secondary-navigation__item ${subTree.size > 0 ? '' : 'noSubtree'}`}>
                      <CoreLink className="secondary-navigation__item__link" onClick={() => setOpenMobileMenu(false)} to={url}>{title}</CoreLink>
                      {subTree.size > 0 && subTree.map((item2) => {
                        const title2 = item2.getIn(['link', 'title'], 'Untitled');
                        const url2 = item2.getIn(['link', 'url'], '');
                        return (
                          <div key={title2} className="secondary-navigation__item__subitem">
                            <CoreLink
                              className="secondary-navigation__item__link__sub"
                              onClick={() => setOpenMobileMenu(false)}
                              to={url2}
                            >
                              <span>{title2}</span>
                            </CoreLink>
                          </div>
                        );
                      })}
                    </li>
                  );
                })}
              </ul>
            );
          }}
        </Menu>
        <Menu id={`simple-links-navigation${menuIdSuffix}`}>
          {(links) => {
            return (
              <ul className="simple-links-navigation__items">
                {links.map((link, index) => {
                  if (!link) {
                    return;
                  }
                  const title = link.getIn(['link', 'title'], 'Untitled');
                  const url = link.getIn(['link', 'url'], '');
                  return (
                    <li key={title} className="simple-links-navigation__item">
                      <CoreLink onClick={() => setOpenMobileMenu(false)} to={url}>{title}</CoreLink>
                    </li>
                  );
                })}
              </ul>
            );
          }}
        </Menu>
      </Container>
    </div>
  );
};

export default NavigationMainMenuMobile;
